var React = require('react');
var cx = require('classnames');

class UnsubscribeButton extends React.Component {
  _unsubscribe() {
    $.ajax({
      type: "DELETE",
      url: Routes.page_deactivate_subscribers_url(this.props.page, this.props.subscriber)
    }).success((msg) => {
      HRB.utils.notify('Subscriber successfully unsubscribed.', {method: 'deferred'});
      window.location = Routes.notifications_page_url(
        this.props.page,
        { domain: null, subdomain: null }
      );
    }).fail(() => {
      HRB.utils.basicFailAndReload();
    });
  }

  render() {
    return (
      <a className="cpt-button style-primary size-small pull-right"
         onClick={this._unsubscribe.bind(this)}>
        UNSUBSCRIBE
      </a>
    )
  }
}

module.exports = UnsubscribeButton;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/unsubscriber.jsx